import {Modal, theme, Typography} from 'antd';
import React from 'react';

interface IProps {
  isOpen: boolean;
  toggleDialog: any;
  text: any;
}

const SimpleAlert: React.FC<IProps> = (props) => {
  const {isOpen, toggleDialog, text} = props;
  const {token}: any = theme.useToken();

  return (
    <Modal open={isOpen} onCancel={toggleDialog} footer={null} centered>
      <Typography.Title level={3} style={{color: token.colorPrimary, paddingTop: 32}}>
        {text.heading}
      </Typography.Title>
      <Typography.Text style={{color: token.colorTextBase, display: 'block', paddingBottom: 32}}>
        <div style={{textAlign: 'center'}}>{text.subtitle}</div>
      </Typography.Text>
    </Modal>
  );
};

export default SimpleAlert;
